import React from 'react';
import { useTranslation } from 'react-i18next';
import useAppContext from '../../../../../context/useAppContext';
import { WeezHeader, EmptyCard, Icon, Button } from '@weezevent/nacre';
import { usePermissions } from '../../../../../user/permissions';

export default function TicketDesignEmptyCard({ event = null, menhirUrl = '' }) {
    const [{ organization }] = useAppContext();
    const { t } = useTranslation();
    const permissions = usePermissions();

    const isBo = React.useMemo(() => event?.id <= 1050000 || permissions.hasRole('ticket-switch'), [event, permissions]);

    return (
        <div>
            <WeezHeader title={t('ticket.ticket_design.title')}>{t('ticket.ticket_design.description')}</WeezHeader>
            <EmptyCard
                image=""
                title={t('ticket.ticket_design.title')}
                subTitle={
                    <>
                        {t('ticket.ticket_design.designs.empty.new_version')}
                        <div style={{ marginTop: '15px' }}>{isBo ? t('ticket.ticket_design.designs.empty.warning') : t('ticket.ticket_design.designs.empty.try')}</div>
                    </>
                }
                cta={
                    <div>
                        <Button
                            as="a"
                            href={`/ticket/O${organization.id}/E${event.id}/settings/tickets_design/designs/new`}
                            icon={<Icon name="plus" />}
                            color="ticket"
                            label={t('ticket.ticket_design.designs.empty.create')}
                        />
                        {isBo && (
                            <Button
                                as="a"
                                target="_blank"
                                href={`${menhirUrl}/ticket/${event.id}`}
                                icon={<Icon name="Reset" />}
                                inverted
                                color="ticket"
                                label={t('ticket.ticket_design.designs.empty.former')}
                            />
                        )}
                    </div>
                }
                hrefContact="mailto:contact@weezevent.com"
                labelContact={t('ticket.ticket_design.designs.empty.more_information')}
                labelLinkContact={t('ticket.creationEvent.help.titleContact')}
            />
        </div>
    );
}
